export enum PermissionType {
  type = '_type',
  class = '_class',
  integrationClass = '_integrationClass',
  integrationType = '_integrationType',
  integrationInstanceId = '_integrationInstanceId',
}
